import { TurnstileInstance, TurnstileProductScopeName } from '@frontend/api/types';

export type Product = {
  name: string;
  scope_name: TurnstileProductScopeName;
  instances: TurnstileInstance[];
};

export type ConnectionContextType = {
  products: Record<string, Product>;
};

export const transformConnectionsToProducts = (
  connections: TurnstileInstance[],
  opalInstanceId: string
): Record<string, Product> => {
  return connections.reduce(
    (acc, instance) => {
      const disabled = instance.opal_instance_id !== opalInstanceId;
      if (!acc[instance.product_name]) {
        acc[instance.product_name] = {
          name: instance.product_name,
          scope_name: instance.product_sku,
          instances: [{ ...instance, disabled }],
        };
        return acc;
      }
      acc[instance.product_name].instances.push({ ...instance, disabled });
      return acc;
    },
    {} as Record<string, Product>
  );
};
